import React from 'react';
import {connect} from 'react-redux';

import {setDiscountSections} from "./discountsActions";
import {
  getCurrentWorkSheetSections,
  getUpdatedDiscountSectionsWithWizardLogic
} from "./discountsFunctions";
import {UI_POPUP_TYPES} from "../../reducers/R_Popups";
import {setUiPopupState} from "../../actions/A_Popups";


const DiscountsAsideDisplayOption = (props) => {
  const {workSheetIndex, wizardLogic, displayOption, discountSections, setDiscountSections, setUiPopupState,
    workSheetsActiveIndex} = props;

  const isActive = workSheetsActiveIndex === workSheetIndex;

  const removeGroupSelection = () => {
    const newWizardLogic = {
      ...wizardLogic,
      displayOptions: wizardLogic.displayOptions.filter(option => option.id !== displayOption.id)
    };
    const updatedSections = getUpdatedDiscountSectionsWithWizardLogic(
      discountSections,
      newWizardLogic,
      workSheetsActiveIndex
    );
    setDiscountSections(updatedSections);
  }

  const onEditDisplayOption = (closePopup, uiPopupContext) => {
    const newWizardLogic = {
      ...wizardLogic,
      displayOptions: wizardLogic.displayOptions.map(option => {
        if (option.id === displayOption.id) {
          return {
            id: option.id,
            forVisualizer: uiPopupContext.forVisualizer,
            forWizardId: uiPopupContext.forWizardId,
            forWizardHashId: uiPopupContext.forWizardHashId,
            forWizardName: uiPopupContext.forWizardName,
            forWizardGroupTitle: uiPopupContext.forWizardGroupTitle,
            forWizardGroupId: uiPopupContext.forWizardGroupId,
            forWizardGroupName: uiPopupContext.forWizardGroupName,
          }
        }
        return option;
      })
    };
    const updatedSections = getUpdatedDiscountSectionsWithWizardLogic(
      discountSections,
      newWizardLogic,
      workSheetIndex
    );
    setDiscountSections(updatedSections);
    closePopup();
  }

  const editWorkSheetClick = () => {
    console.log("displayOption", displayOption);
    const currentSheetSections = getCurrentWorkSheetSections(discountSections, workSheetsActiveIndex);
    setUiPopupState({
      headerTextId: "discounts.addDisplayOptions",
      className: "",
      style: {maxWidth: "480px", maxHeight: "320px"},
      opened: true,
      type: UI_POPUP_TYPES.discountsDisplayOptions,
      context: {
        ...displayOption,
        currentSheetSections,
      },
      buttons: [{}, {
        isSaveButton: true,
        className: "ui-button5 ui-button5--wide text-uppercase ui-button5--green",
        textId: "messageBox.buttons.save",
        onClick: onEditDisplayOption,
      }],
    });
  }

  return (
    <li className={"discounts-sidebar__item flex flex--center flex--between pb-025 pt-025"
      + (isActive ? " bordered--transparent" : "")}>
      <span className="color-blue text-overflow bold flex-item">
        {displayOption.forWizardGroupTitle || displayOption.forWizardGroupName}
      </span>
      {isActive ? (
        <div className="discounts-sidebar__item-buttons">
          <button className="margin-l8 ui-icon-edit ui-icon-edit--hover-white ui-icon-edit--small relative"
                  onClick={editWorkSheetClick}/>
          <button className="-top-05px ml-05 ui-close ui-close--gray ui-close--small"
                  onClick={removeGroupSelection}/>
        </div>
      ) : null}
    </li>
  )
}


const mapStateToProps = (store) => {
  const {discountsReceived, discountSections, workSheetsActiveIndex} = store.discountsState;
  return {
    discountsReceived,
    discountSections,
    workSheetsActiveIndex,
  };
};

const mapDispatchToProps = {
  setDiscountSections,
  setUiPopupState,
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountsAsideDisplayOption);
